import { Themed } from "@client/styles/themes";
import React, { CSSProperties } from "react";

import {
    TestimonialCard as CardValue,
    TestimonialCardsBlock as Value,
} from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { Carousel } from "../GoodcookCarousel";

import styles from "./index.module.scss";

interface CustomCss extends CSSProperties {
    "--slides-visible-cms": string;
}

/**
 * Perhaps overkill, but we want there to always be smart quotes wrapping a
 * quote; the best way to do that is to have them added (they're in CSS pseudos)
 * and make sure the string isn't bringing its own.
 */
export const cleanQuote = (string: string | null) => {
    if (!string) return string;
    const quoteChars = ["“", "”", '"'];
    let cleaned = string;

    if (quoteChars.includes(cleaned[0])) {
        cleaned = cleaned.slice(1);
    }
    if (quoteChars.includes(cleaned[cleaned.length - 1])) {
        cleaned = cleaned.slice(0, -1);
    }

    return cleaned;
};

export const cleanCitation = (string: string | null) => {
    if (!string) return string;
    const dashes = ["—", "–", "-"];
    let cleaned = string;

    if (dashes.includes(cleaned[0])) {
        cleaned = cleaned.slice(1);
    }

    return cleaned;
};

interface Props {
    value: Value;
    id?: string;
}

const TestimonialCard = ({ image, quote, citation }: CardValue) => (
    <Themed theme="white" className={styles.card}>
        <figure className={styles.figure}>
            {image && (
                <ImageChooserBlock
                    value={image}
                    sizes="80px"
                    imageAttrs={{ className: styles.avatar }}
                />
            )}
            <blockquote className={styles.quote}>
                {cleanQuote(quote)}
            </blockquote>
            {citation && (
                <figcaption>
                    <p className={styles.citation}>{cleanCitation(citation)}</p>
                </figcaption>
            )}
        </figure>
    </Themed>
);

export const TestimonialCardsBlock = ({ value, id }: Props) => {
    if (!value.cards || value.cards.length === 0) return <></>;

    return (
        <Carousel
            label={value.block_label!}
            containerProps={{ className: styles.root }}
            scrollContainerProps={{
                className: styles.carousel,
                style: value.layout
                    ? ({ "--slides-visible-cms": value.layout } as CustomCss)
                    : undefined,
            }}
            advanceBy="item"
            controlsClassName={styles.controls}
        >
            {value.cards.map((card, index) => (
                <TestimonialCard
                    key={`testimonials-${id}-${index}`}
                    {...card}
                />
            ))}
        </Carousel>
    );
};
